import { BooleanField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.EMAIL_CAMPAIGN_SETTINGS)
export default class EmailCampaignSettings extends BaseModel {
  @StringField()
  public footer: string

  @BooleanField(true)
  public isTrackLinks: boolean
}
